import PropTypes from 'prop-types'

export const productShape = {
  name: PropTypes.string.isRequired,
  vendorName: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  sizes: PropTypes.array.isRequired
}

export const productFromNetworkShape = {
  product: PropTypes.shape(productShape),
  isFetching: PropTypes.bool,
  error: PropTypes.string
}

export const productsFromNetworkShape = {
  list: PropTypes.arrayOf(PropTypes.shape(productShape)).isRequired,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.string
}

export const productFiltersShape = {
  list: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired
  })).isRequired
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/shop/src/js/shapes/products.js